export const firstOrUndefined = <T>(list: T[] | undefined): T | undefined => {
  if (!list || list.length === 0) {
    return undefined;
  }
  return list[0];
};
